import { useDispatch } from 'react-redux';

import { updateCurrentModule } from 'src/presentation/components/pages/sidekick/threads/actions/threadsUiSlice';

const useOnSave = () => {
  const dispatch = useDispatch();
  return props => {
    dispatch(updateCurrentModule({ moduleData: props.workingStateRef.current }));
  };
};

export default useOnSave;
